module.exports = __webpack_public_path__ + "img/car-shadow-2.957d9a2d.png";